<script lang="ts">
  import { _ } from "svelte-i18n";
  import Container from "$lib/components/Container/Container.svelte";
  import Link from "$lib/components/Link/Link.svelte";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import PageTitle from "$lib/components/PageTitle/PageTitle.svelte";
  import { processInlineLinks } from "$lib/utils/url";

  export let modal = false;
  let href = "";

  const isBrowser = typeof window !== "undefined";
  if (isBrowser) {
    href = window.location.pathname;
  }
</script>

<style lang="scss">
  .privacy-policy {
    &.borderBottom {
      border-bottom: 1px solid $on-surface;

      @include retina {
        border-bottom: 0.5px solid $on-surface;
      }
    }

    &--separator {
      background: $on-surface-10;
      height: 1px;
      width: 100%;
    }
    &--intro {
      margin: 48px 0;
      max-width: 100%;
      &--text {
        margin-bottom: 48px;
      }
      &--link {
        margin-bottom: 24px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    &--body {
      max-width: 100%;
    }
    &--subheader {
      margin: 16px 0;
      scroll-margin-top: 72px;

      @include breakpoint(lg) {
        scroll-margin-top: 116px;
      }
    }

    @include breakpoint(md) {
      &--intro {
        margin: 72px 0;
        max-width: 60%;
        &--text {
          margin-bottom: 72px;
        }
      }
      &--body {
        max-width: 60%;
      }
      &--subheader {
        margin: 20px 0;
      }
    }

    @include breakpoint(lg) {
      &--intro {
        margin: 64px 0;
        &--text {
          margin-bottom: 64px;
        }
      }
      &--subheader {
        margin: 24px 0;
      }
    }
  }
</style>

<div class="privacy-policy" class:borderBottom={!modal}>
  <Container>
    <div class="privacy-policy--header">
      <PageTitle title={$_("privacyPolicy.title")} />
    </div>
    <div class="privacy-policy--separator" />

    <div class="privacy-policy--intro">
      <div class="privacy-policy--intro--text">
        <Typography component="p" variant="body1"
          >{@html processInlineLinks($_("privacyPolicy.intro"))}</Typography
        >
      </div>
      {#each [...Array(15).keys()] as n}
        <div class="privacy-policy--intro--link">
          <Link
            text={$_(`privacyPolicy.section.${n}.title`)}
            href={href + "#" + $_(`privacyPolicy.section.${n}.title`)}
            processedUrl
          />
        </div>
      {/each}
    </div>
    <div class="privacy-policy--separator" />

    <div class="privacy-policy--body">
      {#each [...Array(15).keys()] as n}
        <div class="privacy-policy--block">
          <div
            class="privacy-policy--subheader"
            id={$_(`privacyPolicy.section.${n}.title`)}
          >
            <Typography component="h2" variant="h1"
              >{$_(`privacyPolicy.section.${n}.title`)}</Typography
            >
          </div>
          <Typography component="span" variant="body1"
            >{@html processInlineLinks(
              $_(`privacyPolicy.section.${n}.content`),
            )}</Typography
          >
        </div>
        {#if n !== 14}
          <div class="privacy-policy--separator" />
        {/if}
      {/each}
    </div>
    <div class="privacy-policy--separator" />
  </Container>
</div>
